module.exports = __webpack_public_path__ + "static/media/Notif.e11f0bb3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Icons/Notif.svg
// module id = 1153
// module chunks = 0